
import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import styled from "styled-components"
import { showModal, showNestedModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import excelIconDefault from "../../../images/svg/excel/excel-default.svg"
import excelIconActive from "../../../images/svg/excel/excel-active.svg"
import Btn from "../../shared/button/Btn"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import InputSelect from "../../shared/input/new/InputSelect"
import InputSelectFirma from "../../shared/input/special/InputSelectFirma"
import NumberFormatInput from "../../shared/input/special/NumberFormatInput"
import { validateExcelFile } from "../../../helper/docs/validateExcelFile"
import { toast } from "react-toastify"
import { addLoadBulk, getAllCompanyForLoadBulk, getProjectNameByTaxNo } from "../../../features/loadBulk/loadBulkSlice"
import InputSelectCompany from "../../shared/input/loadBulk/InputSelectCompany"
import InputProjectName from "../../shared/input/loadBulk/InputProjectName"
import InputPublishingType from "../../shared/input/loadBulk/InputPublishingType"
import InputPublishingTypeHour from "../../shared/input/loadBulk/InputPublishingTypeHour"
import { getCompanyProjectName } from "../../../features/isOrtaklari/isOrtaklariSlice"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 580px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 30px 20px 30px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;    
        position: relative;

        .content{
            display: flex;
            flex-direction: column;
            align-items: center;
            color: ${({theme}) => theme.mainTextColor};
            padding:30px 40px;

            .messages{
                margin-top: 10px;
            }
            .error{
                color: var(--color-main);
            }
            .success{
                color: var(--color-green);
            }
            .p1{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
            }

            .p2{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                color: ${({theme}) => theme.secondaryTextColor};
            }

            .img-wrapper{
                margin-top: 50px;
                cursor: pointer;

                
                .excel-icon{
                    width: 152px;
                    height: 152px;
                }
            }

            .file-input{
                display: none;
            }

            .upload-status{
                padding-top: 20px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);

            }

            .bottom-side{
                margin-top: 20px;
                display: flex;
                flex-direction: column;
                gap: 10px;

                p{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                }

                .btn-wrapper{
                    margin-top: 10px;
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                }
            }

            .bottom-side-center{
                margin-top: 10px;
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 15px;

                .file-name{
                    padding: 5px 0;
                    font-size: var(--font-size-md);
                    font-weight: var(--font-weight-lg);
                }
                .admin-select{
                    display: flex;
                    flex-direction: column;
                    .admin-search{
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }
                }
                .time-select{
                    width: 100%;
                    display: flex;
                    margin-top: 10px;
                    flex-direction: column;
                    gap: 10px;
                    .time-title{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                    }
                }
            }
        }

        .layout{
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.9);
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;

            div{
                font-size: 48px;
                font-weight: var(--font-weight-lg);
                color: #fff;
                text-align: center;
            }
        }
    }
`

const yayinlamaSecenekleri = [
    {
        id:1,
        text: "Herkese Yayınla",
        description:"Tüm KAMYOON üyelerine yayınlanacaktır. Tüm üyeler teklif verebilecektir."
    },
    {
        id:2,
        text: "Önce Yük Arayan Araçlarıma - Sonra Herkese Yayınla",
        description:"Önce sürücülerime yayınlanacak; 3 saat sonra tüm KAMYOON üyelerine yayınlanacaktır."
    },
    {
        id:3,
        text: "Yük Arayan Araçlarıma Yayınla",
        description:"Sadece kendi sürücülerime yayınlanacak ve sadece kendi sürücülerim teklif verebilecektir."
    },
    {
        id:4,
        text: "İş Listemde Kalsın",
        description:"Yayınlanmaz. Sadece kendi iş listenizde kalır. Teklif toplayamazsınız. “Herkese Yayınla” seçeneğini tercih etmeniz önerilir."
    }
]

const AddTopluYukModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    const { companyProjectNames } = useSelector(state => state.isOrtaklari)

    const {modalLocation } = useSelector(state => state.modal)
    const {isLoadingTopluYukEkle, topluYukErrorMessage, searchCompanyNameList, allCompanyList, topluYukSuccessMessage} = useSelector(state => state.loadList)


    const {companyListForLoadBulk, projectList} = useSelector(state => state.loadBulk)

    const { lockScroll, unlockScroll } = useScrollLock();

    const [isSubmitted, setIsSubmitted] = useState(false)
    const [isDragging, setIsDragging] = useState(false) 


    const [selectedFile, setSelectedFile] = useState(null)

    const [selectedCompany, setSelectedCompany] = useState(null)

    const [selectedProject, setSelectedProject] = useState(null)

    const [selectedPublishType, setSelectedPublishType] = useState(null)

    const [selectedPublishTypeHour, setSelectedPublishTypeHour] = useState("")


    

    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))

    const containerRef = useRef(null)

    
    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


    //! 
    useEffect(() => {
        if(rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01" || rld === "f84f35ab-0eb1-46a4-84f4-e72b236c3d26"){
            dispatch(getAllCompanyForLoadBulk())
        }
    },[rld])

    useEffect(() => {
        if(selectedCompany?.taxNo){
            dispatch(getProjectNameByTaxNo(selectedCompany?.taxNo))
        }
    },[selectedCompany?.taxNo])


    useEffect(() => {
        if(rld !== "db7bb061-0f64-4eae-9c4f-678a7359fd01" && rld !== "f84f35ab-0eb1-46a4-84f4-e72b236c3d26"){
            dispatch(getCompanyProjectName())
        }
    },[rld])


    const handleDrop = async(e) => {
        e.preventDefault();
        const file = await validateExcelFile({file: e.dataTransfer.files[0], maxSize: 5 * 1024 * 1024, allowedTypes:["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel.sheet.macroEnabled.12"]})
        

        if(file){
            setSelectedFile(file)
        }
        
        setIsDragging(false)
    }


    const handleDragOver = async(e) => {
        e.preventDefault();

        setIsDragging(true)
        // console.log("handleDragOver");
        
        // const file = await validateExcelFile({file: e.dataTransfer.files[0], maxSize: 5 * 1024 * 1024, allowedTypes:["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel.sheet.macroEnabled.12"]})

        // if(file){
        //     setFile(e.dataTransfer.files[0])
        // }
    }

    const handleFileDownload = () => {
        const link = document.createElement('a');
        link.href = `https://egeyurtgrupbucket.s3.eu-north-1.amazonaws.com/ExcelFiles/YukListesi(Sablon).xlsx `;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }


        //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()
        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    const handleSubmit = () => {
        
        setIsSubmitted(true)

        if(rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01" || rld === "f84f35ab-0eb1-46a4-84f4-e72b236c3d26"){

            if(!selectedCompany || !selectedPublishType){
                toast.error(`Lütfen Firma ve Yayınlama Seçeneği seçin.`, {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }

            else if(selectedCompany && selectedPublishType && selectedPublishType?.id === 2 && selectedPublishTypeHour < 1){
                  toast.error(`Lütfen yükünüzün ne zaman yayınlanmasını istediğinizi belirtin.`, {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }

            else{

                const data = {
                    file: selectedFile,
                    companyProjectId: selectedProject?.id ? selectedProject?.id : null,
                    publishing: selectedPublishType?.id,
                    taxNo: selectedCompany?.taxNo,
                    scheduledPublishTimeHours: selectedPublishType?.id === 2 ? selectedPublishTypeHour : null 
                }

                dispatch(addLoadBulk(data))

            }
        }

        else if(rld === "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" || rld === "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228"){


            if(!selectedProject){
                toast.error(`Lütfen Proje Seçin.`, {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }


            else{
                    const data = {
                    file: selectedFile,
                    companyProjectId: selectedProject?.id ? selectedProject?.id : null,
                    publishing: 24,
                    taxNo: null,
                    scheduledPublishTimeHours: null 
                }

                dispatch(addLoadBulk(data))
            }
            
        }

        else if(rld === "c69f25b2-0570-4894-b474-95f4d7467c28" || rld === "3fa786e7-c02b-4bb4-b063-9bc3f9c5f05c"){

            if(!selectedPublishType){
                toast.error(`Lütfen Yayınlama Seçeneği Seçin.`, {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }

            else if(selectedPublishType && selectedPublishType?.id === 2 && selectedPublishTypeHour < 1){
                toast.error(`Lütfen yükünüzün ne zaman yayınlanmasını istediğinizi belirtin.`, {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }

            else{
                const data = {
                    file: selectedFile,
                    companyProjectId: selectedProject?.id ? selectedProject?.id : null,
                    publishing: selectedPublishType?.id,
                    taxNo: null,
                    scheduledPublishTimeHours: selectedPublishType?.id === 2 ? selectedPublishTypeHour : null
                }

                dispatch(addLoadBulk(data))
            }
        }
    }

    const handleDragLeave = (event) => {
        // Eğer fare div sınırları dışına çıkıyorsa isDragging'i false yap
        if (!containerRef.current.contains(event.relatedTarget)) {
          setIsDragging(false);
        }
      };

    const handleChange = async(e) => {

        const file = await validateExcelFile({file: e.target.files[0], maxSize: 5 * 1024 * 1024, allowedTypes: ["text/csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel.sheet.macroEnabled.12"]})

        if(file){
            setSelectedFile(file)
        }
    }

    
    
  return (
    <Container onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}  ref={containerRef} onDrop={handleDrop} onDragOver={handleDragOver} onDragEnd={() => setIsDragging(false)} onDragLeave={handleDragLeave}>
            <div className="content">
                <p className="p1">Toplu yük girişi yapmak için bir excel dosyası yükleyiniz.</p>
                <p className="p2">Excel dosyanızı taşıyarak sisteme yükleyebilirsiniz.</p>
                <label htmlFor="excel-file" className="img-wrapper"  >
                    <img src={selectedFile ? excelIconActive : excelIconDefault} className="excel-icon" alt="" />
                </label>
                <input type="file" id="excel-file" className='file-input' onChange={handleChange} />
                <div className="upload-status">
                    {
                        selectedFile ? "Dosya Yükleme Başarılı" : "Yüklü bir dosya bulunmamaktadır."
                    }
                </div>
                {
                    selectedFile?.name ? 
                    <div className="bottom-side-center">
                        <div className="file-name">{selectedFile?.name}</div>

                        {
                            (rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01" || rld === "f84f35ab-0eb1-46a4-84f4-e72b236c3d26") &&
                            <InputSelectCompany data={selectedCompany?.nameAndTaxNo} setData={setSelectedCompany} labelText={"Firma Seçin(Zorunlu)"} name={"selectedCompanyLoadBulk"} inputWidth={"420px"} initialOptions={companyListForLoadBulk}/>
                        }

                        {
                            (projectList.length > 0 && (rld !== "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" && rld !== "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228")) &&
                            <InputProjectName data={selectedProject?.projectName || ""} setData={setSelectedProject} initialOptions={projectList} inputWidth={"420px"} name={"projectNameToplu"} labelText={`Proje${(rld === "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" || rld === "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228") ? "(Zorunlu)" : ""}`} />
                        }

                        
                        {
                            (rld !== "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" && rld !== "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228") &&
                            <InputPublishingType data={selectedPublishType?.text || ""} setData={setSelectedPublishType} initialOptions={yayinlamaSecenekleri} inputWidth={"420px"} name={"selectedPublishType"} labelText={"Yayınlama Seçeneği(Zorunlu)"} />
                        }


                        {
                            (selectedPublishType?.id && selectedPublishType?.id === 2) &&
                            <InputPublishingTypeHour data={selectedPublishTypeHour} setData={(e) => setSelectedPublishTypeHour(e.target.value.replace(/[^0-9]/g, ''))} inputWidth={"420px"} name={"selectedPublishType"} labelText={"Yükünüz kaç saat sonra Kamyoon üyelerine yayınlansın?(Zorunlu)"} />
                        }


                        
                        {
                            //! nakliyeci yükvereni
                            ((rld !== "db7bb061-0f64-4eae-9c4f-678a7359fd01" && rld !== "f84f35ab-0eb1-46a4-84f4-e72b236c3d26") && companyProjectNames.length > 0) &&
                            <InputProjectName data={selectedProject?.projectName || ""} setData={setSelectedProject} initialOptions={companyProjectNames} inputWidth={"420px"} name={"projectNameToplu"} labelText={`Proje${(rld === "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" || rld === "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228") ? "(Zorunlu)" : ""}`} />
                        }




                        {/* {(rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01" || rld === "f84f35ab-0eb1-46a4-84f4-e72b236c3d26") &&
                            <InputSelectFirma data={searchCompanyName?.nameAndTaxNo} setData={setSearchCompanyName} initialOptions={allCompanyList} name={"searchCompanyName"} labelText={"Firma Adı"} inputWidth={"400px"} />
                        }
                        
                        {((rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01" && searchCompanyName) || (rld !== "db7bb061-0f64-4eae-9c4f-678a7359fd01")) && 
                            <InputProjectName data={selectedProjectAddLoad?.projectName || ""} initialOptions={projectNameOptions} inputWidth={"400px"} name={"projectNameToplu"} labelText={"Proje"} />
                        }
                        
                        {isSubmitted && (rld === ("ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" || "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228")) && !selectedProjectAddLoad && 
                            <p className="error">Lütfen proje seçiniz.</p>
                        }
                        {
                            (rld !== ("ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" || "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228")) &&
                            <InputSelect data={yayinlama?.text} setData={setYayinlama} initialOptions={yayinlamaSecenekleri} inputWidth={"400px"} name={"yayinlama"} labelText={"Yayınlama Seçenekleri"} />
                        } */}

                        {/* {
                            yayinlama?.id === 2 &&
                            <div className="time-select">
                                <div className="time-title">Yükünüz kaç saat sonra Kamyoon üyelerine yayınlansın? </div>
                                <NumberFormatInput data={publishTime} setData={setPublishTime} inputWidth={"150px"} labelText={"Saat"} name={"publishTime"} />
                            </div>
                        } */}

                        <Btn width={"140px"} bgColor="#E85446" color="#fff" handleClick={handleSubmit}>{isLoadingTopluYukEkle ? <SmallSpinner size={"22px"} bgColor={"#fff"} color={"#c3bbbb"}/> : "Gönder"}</Btn>
                        <Btn width={"140px"} bgColor="transparent" borderColor="transparent" color="#E85446" handleClick={() => setSelectedFile(null)}>Yeniden Yükle</Btn>
                    </div>
                    :
                    <div className="bottom-side">
                        <p>Önemli Bilgi</p>
                        <p>Toplu yük girebilmeniz için yüklerinizi şablon excel dosyasına yerleştirmeniz gerekmektedir.</p>
                        <div className="btn-wrapper">
                            <Btn width={"240px"} bgColor="#E85446" color="#fff" handleClick={() => handleFileDownload()}>Şablonu indirmek için tıklayınız</Btn>
                            <Btn width={"240px"} bgColor="#E85446" color="#fff" handleClick={() => dispatch(showNestedModal("allLoadBulk"))}>Toplu Yük Ekleme Sonuçları</Btn>
                        </div>
                    </div>
                }
                <div className="messages">
                    {topluYukSuccessMessage?.map((item) => (
                        <p className="success">{item?.resultMessage}</p>
                    ))}
                    {topluYukErrorMessage?.map((item) => (
                        <p className="error">{item?.resultMessage}</p>
                    ))}
                </div>
                
            </div>
            {
                isDragging && 
                <div className="layout">
                    <div>Dosyayı Buraya Bırakabilirsin</div>
                </div>
            }
        </div>
    </Container>
  )
}

export default AddTopluYukModal
